import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VistaCategoria = ({ categoria, isAdmin, onBack }) => {
  const [view, setView] = useState('tabla'); // tabla, fixture, cargar, resena
  const [estadisticas, setEstadisticas] = useState([]);
  const [fixture, setFixture] = useState([]);
  const [resultados, setResultados] = useState([]);

  useEffect(() => {
    fetchEstadisticas();
    fetchFixture();
    fetchResultados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoria]);

  const fetchEstadisticas = async () => {
    try {
      const response = await axios.get(`${API}/estadisticas/${categoria}`);
      setEstadisticas(response.data);
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
    }
  };

  const fetchFixture = async () => {
    try {
      const response = await axios.get(`${API}/fixture/${categoria}`);
      setFixture(response.data);
    } catch (error) {
      console.error('Error al obtener fixture:', error);
    }
  };

  const fetchResultados = async () => {
    try {
      const response = await axios.get(`${API}/resultados/${categoria}`);
      setResultados(response.data);
    } catch (error) {
      console.error('Error al obtener resultados:', error);
    }
  };

  const handleActualizarDatos = async () => {
    await fetchEstadisticas();
    await fetchResultados();
    alert('✅ Datos actualizados correctamente');
  };

  const handleCargarClick = () => {
    if (!isAdmin) {
      alert('⚠️ Debes iniciar sesión como administrador para cargar resultados. Haz clic en la llave 🔑 en la esquina inferior derecha.');
      return;
    }
    setView('cargar');
  };

  const getResultadoPartido = (fecha, partidoIdx) => {
    return resultados.find(r => r.fecha === fecha && r.partido_idx === partidoIdx);
  };

  return (
    <div className="card">
      <h2>⚽ Categoría {categoria}</h2>
      {categoria === "2019 experimental" && (
        <div style={{
          background: '#fff3cd',
          padding: '10px 15px',
          borderRadius: '8px',
          marginBottom: '15px',
          border: '2px solid #ffc107'
        }}>
          <p style={{ margin: 0, color: '#856404', fontWeight: 'bold' }}>
            🧪 TORNEO EXPERIMENTAL - No suma puntos a la tabla general
          </p>
        </div>
      )}
      
      <div className="nav-buttons">
        <button onClick={() => setView('tabla')} data-testid="tabla-btn">📊 Tabla</button>
        <button onClick={() => setView('fixture')} data-testid="fixture-btn">📅 Fixture</button>
        <button 
          onClick={handleCargarClick} 
          data-testid="cargar-btn"
          className={isAdmin ? "" : "outline"}
        >
          ⚽ Cargar Resultados {!isAdmin && "🔒"}
        </button>
        <button onClick={() => setView('resena')} data-testid="resena-btn">📰 Reseña</button>
        <button className="success" onClick={handleActualizarDatos} data-testid="actualizar-btn">🔄 Actualizar Datos</button>
        <button className="outline" onClick={onBack} data-testid="volver-btn">← Volver a Categorías</button>
      </div>

      {!isAdmin && view === 'cargar' && (
        <div className="warning-message" style={{marginTop: '20px'}}>
          ⚠️ Para cargar resultados, debes iniciar sesión como administrador. Haz clic en la llave 🔑 en la esquina inferior derecha.
        </div>
      )}

      {view === 'tabla' && (
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Equipo</th>
                <th>PJ</th>
                <th>PG</th>
                <th>PE</th>
                <th>PP</th>
                <th>GF</th>
                <th>GC</th>
                <th>DG</th>
                <th>PTS</th>
              </tr>
            </thead>
            <tbody>
              {estadisticas.map((est, index) => {
                const dg = est.gf - est.gc;
                return (
                  <tr key={est.id} data-testid={`equipo-row-${index}`}>
                    <td>{index + 1}</td>
                    <td>{est.equipo}</td>
                    <td>{est.pj}</td>
                    <td>{est.pg}</td>
                    <td>{est.pe}</td>
                    <td>{est.pp}</td>
                    <td>{est.gf}</td>
                    <td>{est.gc}</td>
                    <td>{dg}</td>
                    <td><strong>{est.pts}</strong></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {view === 'fixture' && (
        <div className="grid">
          {fixture.map((fecha) => (
            <div key={fecha.fecha} className="card" style={{ borderTop: '3px solid #FFD700' }}>
              <strong style={{ fontSize: '1.2em', color: '#0055A4' }}>⚽ Fecha {fecha.fecha}</strong>
              <div style={{ marginTop: '10px' }}>
                {fecha.partidos.length === 0 ? (
                  <div style={{ padding: '10px 0', fontStyle: 'italic', color: '#999' }}>
                    🔵 Fecha libre (sin partidos programados)
                  </div>
                ) : (
                  fecha.partidos.map((partido, idx) => {
                    const resultado = getResultadoPartido(fecha.fecha, idx);
                    return (
                      <div key={idx} style={{ padding: '8px 0', borderBottom: '1px solid #eee', fontSize: '0.95em' }}>
                        {resultado ? (
                          <span>
                            <strong>{partido[0]}</strong> <span style={{color: '#0055A4', fontWeight: 'bold'}}>({resultado.goles1})</span> vs <span style={{color: '#0055A4', fontWeight: 'bold'}}>({resultado.goles2})</span> <strong>{partido[1]}</strong>
                          </span>
                        ) : (
                          <span>{partido[0]} vs {partido[1]}</span>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {view === 'cargar' && isAdmin && (
        <CargarResultados 
          categoria={categoria} 
          onActualizar={() => {
            fetchEstadisticas();
            fetchResultados();
          }}
          resultadosExistentes={resultados}
        />
      )}

      {view === 'resena' && (
        <ResenaDinamica categoria={categoria} isAdmin={isAdmin} />
      )}
    </div>
  );
};

const CargarResultados = ({ categoria, onActualizar, resultadosExistentes }) => {
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [partidoIdx, setPartidoIdx] = useState('');
  const [goles1, setGoles1] = useState('');
  const [goles2, setGoles2] = useState('');
  const [fixture, setFixture] = useState([]);
  const [partidosDisponibles, setPartidosDisponibles] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFixture();
  }, []);

  const fetchFixture = async () => {
    try {
      const response = await axios.get(`${API}/fixture/${categoria}`);
      setFixture(response.data);
    } catch (error) {
      console.error('Error al obtener fixture:', error);
    }
  };

  const handleFechaChange = (e) => {
    const fecha = e.target.value;
    setFechaSeleccionada(fecha);
    setPartidoIdx('');
    setGoles1('');
    setGoles2('');
    
    if (fecha) {
      const fechaObj = fixture.find(f => f.fecha === parseInt(fecha));
      setPartidosDisponibles(fechaObj ? fechaObj.partidos : []);
    } else {
      setPartidosDisponibles([]);
    }
  };

  const handlePartidoChange = (e) => {
    const idx = e.target.value;
    setPartidoIdx(idx);
    setGoles1('');
    setGoles2('');
    
    if (idx !== '') {
      // Buscar si ya existe un resultado para este partido
      const resultadoExistente = resultadosExistentes.find(
        r => r.fecha === parseInt(fechaSeleccionada) && r.partido_idx === parseInt(idx)
      );
      
      if (resultadoExistente) {
        setGoles1(resultadoExistente.goles1.toString());
        setGoles2(resultadoExistente.goles2.toString());
        setMensaje('ℹ️ Este partido ya tiene resultado. Puedes editarlo o dejarlo en blanco para eliminarlo.');
      } else {
        setMensaje('');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // Si ambos campos están vacíos, eliminar el resultado
      const payload = {
        categoria,
        fecha: parseInt(fechaSeleccionada),
        partido_idx: parseInt(partidoIdx),
        goles1: goles1 === '' ? null : parseInt(goles1),
        goles2: goles2 === '' ? null : parseInt(goles2)
      };

      const response = await axios.post(`${API}/resultados`, payload);

      setMensaje(`✅ ${response.data.message}`);
      setGoles1('');
      setGoles2('');
      
      // Actualizar datos
      setTimeout(() => {
        onActualizar();
      }, 1000);
    } catch (err) {
      setError(`❌ Error: ${err.response?.data?.detail || 'Error al procesar resultado'}`);
    }
  };

  const handleActualizarDatos = async () => {
    await onActualizar();
    setMensaje('✅ Datos actualizados correctamente');
    setTimeout(() => setMensaje(''), 3000);
  };

  return (
    <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '10px', marginTop: '20px' }}>
      <h3 style={{ color: '#0055A4', marginBottom: '20px' }}>⚽ Cargar Resultado de Partido</h3>
      
      <div style={{ background: '#e7f3ff', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '2px solid #0055A4' }}>
        <p style={{ margin: 0, color: '#0055A4', fontWeight: 'bold' }}>ℹ️ Instrucciones:</p>
        <ul style={{ marginTop: '10px', marginBottom: 0, paddingLeft: '20px' }}>
          <li><strong>Con números:</strong> El partido se marca como jugado y se actualiza la tabla</li>
          <li><strong>En blanco:</strong> El partido se marca como NO jugado y se eliminan las estadísticas</li>
          <li>Puedes editar resultados ya cargados seleccionando el mismo partido</li>
        </ul>
      </div>

      {mensaje && <div className={mensaje.includes('❌') ? 'error-message' : mensaje.includes('ℹ️') ? 'warning-message' : 'success-message'}>{mensaje}</div>}
      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="fecha">Fecha:</label>
          <select 
            id="fecha"
            value={fechaSeleccionada} 
            onChange={handleFechaChange}
            required
            data-testid="select-fecha"
          >
            <option value="">Seleccione una fecha</option>
            {fixture.map(f => (
              <option key={f.fecha} value={f.fecha}>Fecha {f.fecha}</option>
            ))}
          </select>
        </div>

        {partidosDisponibles.length > 0 && (
          <div>
            <label htmlFor="partido">Partido:</label>
            <select 
              id="partido"
              value={partidoIdx} 
              onChange={handlePartidoChange}
              required
              data-testid="select-partido"
            >
              <option value="">Seleccione un partido</option>
              {partidosDisponibles.map((p, idx) => (
                <option key={idx} value={idx}>
                  {p[0]} vs {p[1]}
                </option>
              ))}
            </select>
          </div>
        )}

        {partidoIdx !== '' && (
          <div style={{ background: 'white', padding: '15px', borderRadius: '8px', marginTop: '15px', border: '2px solid #FFD700' }}>
            <h4 style={{ color: '#0055A4', marginBottom: '15px' }}>
              {partidosDisponibles[parseInt(partidoIdx)][0]} vs {partidosDisponibles[parseInt(partidoIdx)][1]}
            </h4>

            <div className="form-grid">
              <div>
                <label htmlFor="goles1">{partidosDisponibles[parseInt(partidoIdx)][0]} (deja en blanco si no se jugó)</label>
                <input
                  id="goles1"
                  type="number"
                  min="0"
                  value={goles1}
                  onChange={(e) => setGoles1(e.target.value)}
                  placeholder="Goles o vacío"
                  data-testid="goles1-input"
                />
              </div>
              <div>
                <label htmlFor="goles2">{partidosDisponibles[parseInt(partidoIdx)][1]} (deja en blanco si no se jugó)</label>
                <input
                  id="goles2"
                  type="number"
                  min="0"
                  value={goles2}
                  onChange={(e) => setGoles2(e.target.value)}
                  placeholder="Goles o vacío"
                  data-testid="goles2-input"
                />
              </div>
            </div>

            <button type="submit" className="primary" style={{ width: '100%' }} data-testid="guardar-resultado-btn">
              {goles1 === '' || goles2 === '' ? '🗑️ Eliminar Resultado' : '💾 Guardar Resultado'}
            </button>
          </div>
        )}
      </form>

      <div style={{ marginTop: '20px' }}>
        <button 
          type="button" 
          className="success" 
          onClick={handleActualizarDatos} 
          style={{ width: '100%' }}
          data-testid="actualizar-datos-btn"
        >
          🔄 Actualizar Datos
        </button>
      </div>
    </div>
  );
};

const ResenaDinamica = ({ categoria, isAdmin }) => {
  const [resena, setResena] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultadosCount, setResultadosCount] = useState(0);
  const [existe, setExiste] = useState(false);

  useEffect(() => {
    cargarResena();
  }, [categoria]);

  const cargarResena = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/resena/${categoria}`);
      setResena(response.data.resena);
      setResultadosCount(response.data.resultados_count);
      setExiste(response.data.existe || false);
    } catch (error) {
      console.error('Error al cargar reseña:', error);
      setResena('Error al cargar la reseña deportiva. Por favor, intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const generarNuevaResena = async () => {
    if (!isAdmin) {
      alert('⚠️ Debes ser administrador para generar reseñas. Inicia sesión con la llave 🔑');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/resena/${categoria}/generar`);
      setResena(response.data.resena);
      setResultadosCount(response.data.resultados_count);
      setExiste(true);
      alert('✅ Reseña generada exitosamente');
    } catch (error) {
      console.error('Error al generar reseña:', error);
      alert('❌ Error al generar reseña. Por favor, intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ 
        background: '#f0f8ff', 
        padding: '15px', 
        borderRadius: '8px', 
        marginBottom: '15px',
        border: '2px solid #0055A4'
      }}>
        <p style={{ margin: 0, color: '#0055A4', fontWeight: 'bold', fontSize: '1.1em' }}>
          🤖 Reseña Deportiva {existe ? 'Generada' : 'Pendiente'} por IA
        </p>
        <p style={{ margin: '5px 0 0 0', fontSize: '0.9em', color: '#666' }}>
          {existe 
            ? `Análisis basado en ${resultadosCount} partido${resultadosCount !== 1 ? 's' : ''} jugado${resultadosCount !== 1 ? 's' : ''}`
            : 'El administrador puede generar el análisis deportivo'
          }
        </p>
        {isAdmin && (
          <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#28a745', fontWeight: 'bold' }}>
            🔑 Modo Administrador: Puedes generar y actualizar reseñas
          </p>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '2em', marginBottom: '10px' }}>⚽</div>
          <p>Generando reseña deportiva...</p>
        </div>
      ) : (
        <div style={{ 
          lineHeight: '1.8', 
          fontSize: '1.05em',
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          border: '1px solid #e0e0e0'
        }}>
          <p style={{ whiteSpace: 'pre-wrap' }}>{resena}</p>
        </div>
      )}

      {isAdmin && (
        <div style={{ marginTop: '15px', textAlign: 'center' }}>
          <button 
            onClick={generarNuevaResena}
            disabled={loading}
            className="success"
            style={{ minWidth: '200px' }}
            data-testid="generar-resena-btn"
          >
            {loading ? '⏳ Generando...' : existe ? '🔄 Regenerar Reseña' : '✨ Generar Reseña'}
          </button>
          {!existe && resultadosCount > 0 && (
            <p style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
              Hay {resultadosCount} partido{resultadosCount !== 1 ? 's' : ''} sin reseña
            </p>
          )}
        </div>
      )}

      {!isAdmin && !existe && resultadosCount > 0 && (
        <div style={{ 
          marginTop: '15px', 
          textAlign: 'center',
          background: '#fff3cd',
          padding: '15px',
          borderRadius: '8px',
          border: '1px solid #ffc107'
        }}>
          <p style={{ margin: 0, color: '#856404' }}>
            ℹ️ Hay {resultadosCount} partido{resultadosCount !== 1 ? 's' : ''} jugado{resultadosCount !== 1 ? 's' : ''}. El administrador generará pronto el análisis deportivo.
          </p>
        </div>
      )}
    </div>
  );
};

export default VistaCategoria;